"use client";

import { formatMoney } from "@faire/web--source/common/money";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import omit from "lodash/omit";
import React from "react";

import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";
import { Price } from "@faire/retailer/views/product/ProductDetails/Price/Price";
import { IPriceTextProps } from "@faire/retailer/views/product/ProductDetails/Price/PriceProps";

export type ClientFormatMoneyPriceWrapperProps = Pick<
  ILeanProductTile,
  | "min_option_wholesale_price"
  | "min_option_wholesale_promo_price"
  | "min_option_retail_price"
> &
  Omit<
    IPriceTextProps,
    "originalPrice" | "wholesalePrice" | "retailPrice" | "isUKRetailer"
  >;

export const PriceWithClientFormatMoney: React.FC<
  ClientFormatMoneyPriceWrapperProps
> = (props) => {
  const originalPrice = props.min_option_wholesale_price
    ? formatMoney({
        money: props.min_option_wholesale_price,
        omitCentsIfZero: true,
      })
    : "";

  const wholesalePrice = props.min_option_wholesale_promo_price
    ?.discounted_item_price
    ? formatMoney({
        money: props.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true,
      })
    : originalPrice;

  const retailPrice = props.min_option_retail_price
    ? formatMoney({
        money: props.min_option_retail_price,
        omitCentsIfZero: true,
      })
    : "";

  const { isUK: isUKRetailer } = useRetailerStore(["isUK"]);

  const clientPriceProps: IPriceTextProps = {
    ...omit(props, [
      "min_option_retail_price",
      "min_option_wholesale_promo_price",
      "min_option_retail_price",
    ]),
    originalPrice,
    wholesalePrice,
    retailPrice,
    isUKRetailer,
  };

  return <Price {...clientPriceProps} />;
};
